import React, { PureComponent }  from 'react';

import Filters from '../../../common/Filters';
import CloseIcon from '@mui/icons-material/Close';
import Paper from '@mui/material/Paper';
import { connect } from 'react-redux';

import {
  encodeFilterForUrl,
  isNotPlaceholderFilter,
  isNotSearchFilter,
  removeUrlParameter,
  setUrlParameter,
  getRstDataMap,
} from '../../../utils';

 class Filtration extends PureComponent {
  state = {
    filters: {
      trpls: [],
    },
  };

  onFilterBtnClick = (filters, sValue) => {
    const { updateData, setFilterToParentState } = this.props;

    const filter = this.state.filters;
    filter.isDataLoaded = false;

    this.setState({ filters }, () => {
      const newTrpls = filters.map(filter => ({ ...filter }));

      filter.trpls = newTrpls;

      const filtersForUrl = [
        ...filter.trpls
          .filter(isNotSearchFilter)
          .filter(isNotPlaceholderFilter)
          .map(encodeFilterForUrl)
      ];

      if (filtersForUrl.length) {
        setUrlParameter('filters', JSON.stringify(filtersForUrl));
      } else {
        removeUrlParameter('filters');
      }

      if (sValue) {
        setUrlParameter('search_query', sValue);
      } else {
        removeUrlParameter('search_query');
      }

      filters = filter;

      this.setState({ filters, searchValue: sValue || '' });

      setFilterToParentState(filters.trpls);

      updateData(filters.trpls, true);
    });
  };

  render () {
    const {
      light_meta_and_ops,
      filterFromUrl,
      showPidsIds,
      concept,
      classes,
      onClose,
      nodes,
    } = this.props;

    const filtersRstDataMap = getRstDataMap(showPidsIds, concept, light_meta_and_ops.setup_rbox_light);

    return (
      <React.Fragment>
        <Paper style={{ width: 'fit-content', paddingRight: '20px' }} className={classes.glassBG} elevation={0}>
          {onClose ?
            <div style={{ position: 'absolute', right: '5px', top: '5px', cursor: 'pointer'  }}>
              <CloseIcon style={{ fontSize: 14 }}
                onClick={() => onClose()}
              />
            </div>
          : null}
            <Filters
              nodes={nodes}
              loaded={true}
              ancestor={concept}
              callbacks={{ onFilterBtnClick: this.onFilterBtnClick }}
              filterBtnText="Filter"
              filterByNodeTitle={false}
              rstDataMap={filtersRstDataMap}
              initialFilters={filterFromUrl}
            />
        </Paper>
      </React.Fragment>
    );
  }
}

export default connect((state) => (
  {
    light_meta_and_ops: state.meta.light_meta_and_ops,
  }
  ))(Filtration);
